import { render, staticRenderFns } from "./ReportPersonModal.vue?vue&type=template&id=9212a778"
import script from "./ReportPersonModal.vue?vue&type=script&lang=js"
export * from "./ReportPersonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports